import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const useFocusTarget = (ready) => {
  const [params] = useSearchParams();
  const focus = params.get("focus");
  useEffect(() => {
    if (!ready || !focus) { return; }
    let tries = 0;
    const id = setInterval(() => {
      const el = document.querySelector(`[data-testid='${focus}']`);
      if (!el && ++tries < 15) { return; }
      clearInterval(id);
      if (!el) { return; }
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("xd-focus-flash");
      if (["INPUT", "TEXTAREA"].includes(el.tagName)) { el.focus({ preventScroll: true }); }
      setTimeout(() => el.classList.remove("xd-focus-flash"), 2600);
    }, 200);
    return () => clearInterval(id);
  }, [ready, focus]);
};
